import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiCheckCircle, FiFileText } = FiIcons;

const Header = () => {
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="bg-white shadow-sm border-b border-slate-200"
    >
      <div className="container mx-auto px-6 py-6">
        <div className="flex items-center justify-center">
          <div className="flex items-center gap-4">
            <div className="rounded-xl">
              <img 
                src="http://devserver.pressupwards.com/wp-content/uploads/2025/08/Screenshot-2025-08-03-103311.png" 
                alt="Blocksmith Logo" 
                className="w-12 h-12 object-contain"
              />
            </div>
            <div className="flex items-center gap-3">
              <h1 className="text-3xl font-bold text-slate-800">Blocksmith</h1>
              <SafeIcon icon={FiArrowRight} className="text-slate-400 text-xl" />
              <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                Elementor
              </h1>
            </div>
          </div>
        </div>
        <p className="text-center text-slate-600 mt-3 text-lg">
          Convert HTML & CSS to native Elementor JSON templates
        </p>
        <div className="flex flex-col items-center mt-4 gap-2">
          <div className="inline-flex items-center gap-2 bg-green-50 text-green-700 px-4 py-2 rounded-lg border border-green-200">
            <SafeIcon icon={FiCheckCircle} className="text-green-600" />
            <span className="text-sm font-medium">Generates valid Elementor JSON format</span>
          </div>
          <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-lg border border-blue-200 mt-2">
            <SafeIcon icon={FiFileText} className="text-blue-600" />
            <span className="text-sm font-medium">
              Follows proper Elementor structure: sections → columns → widgets
            </span>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;